<template>
	<div id="app">
		<div
			id="detection-theme"
			style="display: none; background-color: canvas; color-scheme: light"
		/>
		<router-view />
		<MainErrors />
		<modal-portals />
	</div>
</template>

<script>
import MainErrors from './components/MainErrors'
import { mapActions, mapMutations, mapState } from 'vuex'
import ModalPortals from '@/components/modals/ModalPortals.vue'

export default {
	name: 'App',

	components: {
		ModalPortals,
		MainErrors
	},

	computed: {
		...mapState('ui', ['isMobileScreen', 'isScreenMore575', 'isScreenMore480'])
	},

	mounted() {
		this.detectTheme()
		this.setResizeListener()
		this.checkIsMobile()
		this.detectUserPlatform()
		this.setIsDesktopDevice()
	},

	beforeDestroy() {
		this.removeResizeListener()
	},

	methods: {
		...mapActions('ui', [
			'setIsScreenMore575',
			'setIsScreenMore480',
			'detectUserPlatform',
			'setIsDesktopDevice'
		]),

		...mapMutations('ui', [
			'setIsForcedDarkChrome',
			'setIsDarkFromOS',
			'setIsMobileScreen'
		]),

		setResizeListener() {
			window.addEventListener('resize', this.checkIsMobile)
		},

		removeResizeListener() {
			window.removeEventListener('resize', this.checkIsMobile)
		},

		checkIsMobile() {
			if (!window) return

			const width = window.innerWidth

			if (!width) return

			this.check767Width(width)
			this.check575Width(width)
			this.check480Width(width)
		},

		check767Width(width) {
			if (width > 767 && this.isMobileScreen) {
				this.setIsMobileScreen(false)

				return
			}

			if (width <= 767 && !this.isMobileScreen) {
				this.setIsMobileScreen(true)
			}
		},

		check575Width(width) {
			if (width > 575 && !this.isScreenMore575) {
				this.setIsScreenMore575(true)

				return
			}

			if (width <= 575 && this.isScreenMore575) {
				this.setIsScreenMore575(false)
			}
		},

		check480Width(width) {
			if (width > 480 && !this.isScreenMore480) {
				this.setIsScreenMore480(true)

				return
			}

			if (width <= 480 && this.isScreenMore480) {
				this.setIsScreenMore480(false)
			}
		},

		detectTheme() {
			if (window.matchMedia) {
				const isDarkFromOS = window.matchMedia('(prefers-color-scheme: dark)')
					.matches

				const detectionDiv = document.querySelector('#detection-theme')
				// If the computed style is not white then the page is in Auto Dark Theme.
				const isForcedDarkChrome =
					getComputedStyle(detectionDiv).backgroundColor !==
					'rgb(255, 255, 255)'
				this.setIsForcedDarkChrome(isForcedDarkChrome)
				this.setIsDarkFromOS(isDarkFromOS)

				window
					.matchMedia('(prefers-color-scheme: dark)')
					.addEventListener('change', event => {
						const newColorScheme = event.matches ? 'dark' : 'light'
						this.setIsDarkFromOS(newColorScheme === 'dark')
					})
			}
		}
	}
}
</script>

<style lang="scss">
@import 'assets/styles/main';
</style>
